import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { min } from "rxjs/operators";
import { UserService } from "../../../../shared";
import { StringIntRequest } from "../../services/StringIntRequest";
import { SysAdminService } from "../../services/sysadmin.service";
import { CreateUserRequestModel } from "../shared/CreateUserRequestModel";
import { School } from "../shared/School";
import { UpdateUserRequestModel } from "../shared/UpdateUserRequestModel";
import { UserGroupInfo } from "../shared/UserGroupInfo";
import { UserRoleInfo } from "../shared/UserRoleInfo";
import { UserModifyDetailsComponent } from "./user-modify-details/user-modify-details.component";
import { UserModifyEmailComponent } from "./user-modify-email/user-modify-email.component";
import { UserModifyRolesComponent } from "./user-modify-roles/user-modify-roles.component";
import { UserModifySchoolsComponent } from "./user-modify-schools/user-modify-schools.component";
import { UserModifyUserGroupsComponent } from "./user-modify-user-groups/user-modify-user-groups.component";

@Component({
	selector: "app-user-modify",
	templateUrl: "./user-modify.component.html",
	styleUrls: ["./user-modify.component.css"],
})
export class UserModifyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.EditMode = this.dialogConfig.data.EditMode;
		this.UserID = this.dialogConfig.data.UserID;

		this.loadPreferences();

		if (this.EditMode == true) {
			this.UserDetailsStatus = 1;
			this.SchoolsStatus = 1;
			this.RolesStatus = 1;
			this.UserGroupsStatus = 1;
			this.EmailStatus = 1;

			this.loadSchoolRoles();
		} else {
			this.SchoolID = this.dialogConfig.data.SchoolID;
		}
	}

	//////////////////////////////////////////////////////////////////////////////////
	//#region  Data
	//////////////////////////////////////////////////////////////////////////////////

	EditMode: any = false;
	UserID: any = -1;

	PageIndex: number = 0;

	errorMessage: any = "";

	//
	// Page Statuses
	// 0 = Not visited
	// 1 = Finished
	// 2 = Error
	//
	UserDetailsStatus: number = 0;
	SchoolsStatus: number = 0;
	RolesStatus: number = 0;
	UserGroupsStatus: number = 0;
	EmailStatus: number = 0;

	@ViewChild(UserModifyDetailsComponent)
	userDetailsRef: UserModifyDetailsComponent;

	@ViewChild(UserModifySchoolsComponent)
	schoolRef: UserModifySchoolsComponent;

	@ViewChild(UserModifyRolesComponent)
	roleRef: UserModifyRolesComponent;

	@ViewChild(UserModifyUserGroupsComponent)
	userGroupRef: UserModifyUserGroupsComponent;

	@ViewChild(UserModifyEmailComponent)
	emailRef: UserModifyEmailComponent;

	UserLevelID: any = 3;
	lstSchool: any = [];

	Username: any = "";
	PersonName: any = "";
	SchoolID: any = 0;

	Processing: any = false;
	SchoolRoleLoading: any = false;

	PreferenceLoading: any = false;
	UserAdminManualEmail: boolean = false;
	ModifyUserShowUserGroups: number = 1;
	UsernameMustMatchEmail: boolean = false;
	UsernameEmailMustHaveDomain: boolean = false;

	//#endregion
	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	//#region Load Data
	//////////////////////////////////////////////////////////////////////////////////

	loadPreferences() {
		this.PreferenceLoading = true;

		var result = this.sysAdminService.SysAdminUserModifyPreferenceSelect();
		result.subscribe(
			(response: any) => {
				if (response != null) {
					if (response.UserAdminManualEmail != undefined) {
						this.UserAdminManualEmail = response.UserAdminManualEmail;
					}
					if (response.ModifyUserShowUserGroups != undefined) {
						this.ModifyUserShowUserGroups = response.ModifyUserShowUserGroups;
					}
					if (response.UsernameMustMatchEmail != undefined) {
						this.UsernameMustMatchEmail = response.UsernameMustMatchEmail;
					}
					if (response.UsernameEmailMustHaveDomain != undefined) {
						this.UsernameEmailMustHaveDomain = response.UsernameEmailMustHaveDomain;
					}
				}

				this.PreferenceLoading = false;
			},
			(error) => {
				this.PreferenceLoading = false;
			}
		);
	}

	loadSchoolRoles() {
		this.SchoolRoleLoading = true;

		var result = this.sysAdminService.SysAdminSchoolRoleSelect(this.UserID);
		result.subscribe(
			(response) => {
				// console.log("Load School Roles");
				// console.log(response);

				var Data: any = response;

				this.schoolRef.lstSchool = Data.lstSchools;
				this.roleRef.lstSchool = Data.lstSchools;
				this.roleRef.School = this.roleRef.lstSchool[0];
				this.emailRef.lstSchool = Data.lstSchools;

				for (var z = 0; z < Data.lstRoles.length; z++) {
					var next = Data.lstRoles[z];

					var School: any = null;

					for (var i = 0; i < Data.lstSchools.length; i++) {
						var nextSchool = Data.lstSchools[i];

						// console.log("Next School");
						// console.log(nextSchool);

						if (next.Item1 == nextSchool.SchoolID) {
							School = nextSchool;
							break;
						}
					}

					var RoleList = this.roleRef.SchoolRoleData.get(School);

					if (RoleList == undefined) {
						this.roleRef.SchoolRoleData.set(School, [next.Item2]);
					} else {
						RoleList = [...RoleList, next.Item2];
						this.roleRef.SchoolRoleData.set(School, RoleList);
					}
				}

				this.SchoolRoleLoading = false;
			},
			(error) => {
				this.SchoolRoleLoading = false;
			}
		);
	}

	//#endregion
	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	//#region Buttons
	//////////////////////////////////////////////////////////////////////////////////

	onNavClick(NextIndex) {
		if (this.IsLoading() == true || this.userDetailsRef.IsLoading() == true) {
			return;
		}

		this.SetNavStatus(this.PageIndex);
		this.PageIndex = NextIndex;
	}

	onBack() {
		var nextIndex = this.PageIndex - 1;

		// Skip User Groups if turned off
		if (nextIndex == 3 && this.ShowUserGroups() == false) {
			nextIndex -= 1;
		}

		this.onNavClick(nextIndex);
	}

	onNext() {
		var nextIndex = this.PageIndex + 1;

		// Skip User Groups if turned off
		if (nextIndex == 3 && this.ShowUserGroups() == false) {
			nextIndex += 1;
		}

		this.onNavClick(nextIndex);
	}

	//////////////////////////
	//#region Add User
	//////////////////////////

	onAdd() {
		this.errorMessage = "";

		//
		// Error handling
		//

		this.Processing = true;

		if (this.UserDetailsCheckErrors(true) == false) {
			this.Processing = false;
			return;
		}
		if (this.SchoolsCheckErrors(true) == false) {
			this.Processing = false;
			return;
		}
		if (this.RolesCheckErrors(true) == false) {
			this.Processing = false;
			return;
		}
		if (this.UserGroupsCheckErrors(true) == false) {
			this.Processing = false;
			return;
		}
		if (this.EmailCheckErrors(true) == false) {
			this.Processing = false;
			return;
		}

		//
		// Check if username is already in use
		//

		let parms: StringIntRequest = {
			num: -1,
			str: this.userDetailsRef.Username,
		};

		var result = this.sysAdminService.UsersIsNameUsed(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == false) {
					this.Processing = false;

					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.onFinishAdd();
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onFinishAdd() {
		//
		//Create Request Model
		//

		let ModelSchools: School[] = [];
		for (var i = 0; i < this.schoolRef.lstSchool.length; i++) {
			var next = this.schoolRef.lstSchool[i];

			let val1: School = {
				SchoolID: next.SchoolID,
				SchoolName: next.SchoolName,
				SchoolNumber: next.SchoolID.toString(),
			};

			ModelSchools = [...ModelSchools, val1];
		}

		let ModelGroups: UserGroupInfo[] = [];
		for (var i = 0; i < this.userGroupRef.lstUserGroup.length; i++) {
			var next = this.userGroupRef.lstUserGroup[i];

			let val1: UserGroupInfo = {
				Active: next.Active,
				UserGroupCD: next.UserGroupCD,
				UserGroupDesc: next.UserGroupDesc,
				UserGroupID: next.UserGroupID,
				UserLevelID: next.UserLevelID,
				UserLevelDesc: next.UserLevelDesc,
				SchoolID: next.SchoolID,
			};

			ModelGroups = [...ModelGroups, val1];
		}

		let ModelRoles: UserRoleInfo[] = [];

		// RoleID: number,
		// SchoolID: number,
		// RoleDesc: string

		this.roleRef.SchoolRoleData.forEach((value, key) => {
			//
			// Key = School Object
			// Value = List of Role Objects
			//
			// Go through each role for the school
			//
			for (var z = 0; z < value.length; z++) {
				var next = value[z];

				let nextRole: UserRoleInfo = {
					RoleID: next.RoleID,
					SchoolID: key.SchoolID,
					RoleDesc: next.RoleDesc,
				};

				ModelRoles = [...ModelRoles, nextRole];
			}
		});

		//
		// Email Provider vs. Manual
		//

		var StartEmail = this.emailRef.Email;
		var EndEmail = "";

		if (this.emailRef.DomainOption == "Manual") {
			var atInd = String(this.emailRef.Email).indexOf("@");

			StartEmail = String(this.emailRef.Email).substring(0, atInd);
			EndEmail = String(this.emailRef.Email).substring(atInd);

			EndEmail = EndEmail.replace("@", "");
		} else {
			StartEmail = this.emailRef.Email;
		}

		let parms: CreateUserRequestModel = {
			UserName: this.userDetailsRef.Username,
			Password: this.userDetailsRef.Password,
			PersonID: this.userDetailsRef.Person.PersonID,
			UserLevel: this.userDetailsRef.UserLevel.UserLevelID,
			Schools: ModelSchools,
			UserGroups: ModelGroups,
			Roles: ModelRoles,
			SelectedEmail: StartEmail,
			EmailProviderID: this.emailRef.DomainOption == "Dropdown" ? this.emailRef.EmailDomain.EmailProviderID : 1,
			EmailProviderInfo: this.emailRef.DomainOption == "Dropdown" ? this.emailRef.EmailDomain.EmailProviderEmailInfo : EndEmail,
		};

		//Call SP to create the user
		var result = this.sysAdminService.CreateUser(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "User was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the User",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	//#endregion
	//////////////////////////

	//////////////////////////
	//#region Update User
	//////////////////////////

	onUpdate() {
		this.errorMessage = "";

		//
		// Error handling
		//

		this.Processing = true;

		if (this.UserDetailsCheckErrors(true) == false) {
			this.Processing = false;
			return;
		}
		if (this.SchoolsCheckErrors(true) == false) {
			this.Processing = false;
			return;
		}
		if (this.RolesCheckErrors(true) == false) {
			this.Processing = false;
			return;
		}
		if (this.UserGroupsCheckErrors(true) == false) {
			this.Processing = false;
			return;
		}
		if (this.EmailCheckErrors(true) == false) {
			this.Processing = false;
			return;
		}

		//
		// Check if username is already in use
		//

		let parms: StringIntRequest = {
			num: this.UserID,
			str: this.userDetailsRef.Username,
		};

		var result = this.sysAdminService.UsersIsNameUsed(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == false) {
					this.Processing = false;

					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.onFinishUpdate();
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onFinishUpdate() {
		//
		//Create Request Model
		//

		let ModelSchools: School[] = [];
		for (var i = 0; i < this.schoolRef.lstSchool.length; i++) {
			var next = this.schoolRef.lstSchool[i];

			let val1: School = {
				SchoolID: next.SchoolID,
				SchoolName: next.SchoolName,
				SchoolNumber: next.SchoolID.toString(),
			};

			ModelSchools = [...ModelSchools, val1];
		}

		let ModelGroups: UserGroupInfo[] = [];
		for (var i = 0; i < this.userGroupRef.lstUserGroup.length; i++) {
			var next = this.userGroupRef.lstUserGroup[i];

			let val1: UserGroupInfo = {
				Active: next.Active,
				UserGroupCD: next.UserGroupCD,
				UserGroupDesc: next.UserGroupDesc,
				UserGroupID: next.UserGroupID,
				UserLevelID: next.UserLevelID,
				UserLevelDesc: next.UserLevelDesc,
				SchoolID: next.SchoolID,
			};

			ModelGroups = [...ModelGroups, val1];
		}

		let ModelRoles: UserRoleInfo[] = [];

		// RoleID: number,
		// SchoolID: number,
		// RoleDesc: string

		this.roleRef.SchoolRoleData.forEach((value, key) => {
			//
			// Key = School Object
			// Value = List of Role Objects
			//
			// Go through each role for the school
			//
			for (var z = 0; z < value.length; z++) {
				var next = value[z];

				let nextRole: UserRoleInfo = {
					RoleID: next.RoleID,
					SchoolID: key.SchoolID,
					RoleDesc: next.RoleDesc,
				};

				ModelRoles = [...ModelRoles, nextRole];
			}
		});

		//
		// Email Provider vs. Manual
		//

		var StartEmail = this.emailRef.Email;
		var EndEmail = "";

		if (this.emailRef.DomainOption == "Manual") {
			var atInd = String(this.emailRef.Email).indexOf("@");

			StartEmail = String(this.emailRef.Email).substring(0, atInd);
			EndEmail = String(this.emailRef.Email).substring(atInd);

			EndEmail = EndEmail.replace("@", "");
		} else {
			StartEmail = this.emailRef.Email;
		}

		let parms: UpdateUserRequestModel = {
			UserID: this.UserID,
			UserName: this.userDetailsRef.Username,
			PasswordChanged: this.userDetailsRef.Password != null && this.userDetailsRef.Password != "" ? 1 : 0,
			Password: this.userDetailsRef.Password,
			PersonID: this.userDetailsRef.Person.PersonID,
			UserLevel: this.userDetailsRef.UserLevel.UserLevelID,
			Schools: ModelSchools,
			UserGroups: ModelGroups,
			Roles: ModelRoles,
			SelectedEmail: StartEmail,
			EmailProviderID: this.emailRef.DomainOption == "Dropdown" ? this.emailRef.EmailDomain.EmailProviderID : 1,
			EmailProviderInfo: this.emailRef.DomainOption == "Dropdown" ? this.emailRef.EmailDomain.EmailProviderEmailInfo : EndEmail,
			EmailID: this.emailRef.EmailID,
		};

		//Call SP to create the user
		var result = this.sysAdminService.UpdateUser(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "User was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the User",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	//#endregion
	//////////////////////////

	onClose() {
		this.ref.close(0);
	}

	//#endregion
	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	//#region Events
	//////////////////////////////////////////////////////////////////////////////////

	//#endregion
	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	//#region Helpers
	//////////////////////////////////////////////////////////////////////////////////

	SetNavStatus(PageIndex) {
		if (PageIndex == 0) {
			this.UserLevelID = this.userDetailsRef.UserLevel.UserLevelID;
			this.Username = this.userDetailsRef.Username;

			if (this.userDetailsRef.School != undefined) {
				this.SchoolID = this.userDetailsRef.School.SchoolID;
			} else {
				this.SchoolID = 0;
			}

			if (this.userDetailsRef.Person != undefined) {
				this.PersonName = this.userDetailsRef.Person.PersonName;
			} else {
				this.PersonName = "";
			}

			this.UserDetailsCheckErrors(false);
		}
		if (this.SchoolsStatus != 0 || PageIndex == 1) {
			this.SchoolsCheckErrors(false);
		}
		if (this.RolesStatus != 0 || PageIndex == 2) {
			this.RolesCheckErrors(false);
		}
		if (this.UserGroupsStatus != 0 || PageIndex == 3) {
			this.UserGroupsCheckErrors(false);
		}
		if (this.EmailStatus != 0 || PageIndex == 4) {
			this.EmailCheckErrors(false);
		}
	}

	UserDetailsCheckErrors(ShowErrorMessage) {
		// console.log("UserDetailsCheckErrors");

		//
		// Check Loading
		//
		if (this.userDetailsRef.IsLoading() == true) {
			// this.UserDetailsStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "User Details Still Loading";
			}

			return false;
		}

		//
		// Check Username
		//
		if (this.ValidUserName(ShowErrorMessage) == false) {
			return false;
		}

		//
		// Check Password
		//
		if (this.ValidPassword(ShowErrorMessage) == false) {
			return false;
		}

		//
		// Only Check Username already used when you try to add a user
		//

		//
		// Check Person is valid
		//
		if (this.userDetailsRef.Person == undefined || this.userDetailsRef.Person.PersonID == undefined || this.userDetailsRef.Person.PersonID <= 0) {
			this.UserDetailsStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Select a Staff Member. New schools will have to create one in Staff/View Staff.";
			}
			return false;
		}

		//
		// Passed all tests
		//
		this.UserDetailsStatus = 1;
		return true;
	}

	ValidUserName(ShowErrorMessage) {
		if (this.userDetailsRef.Username == "") {
			this.UserDetailsStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Enter a Username";
			}

			return false;
		}

		if (this.userDetailsRef.Username.length < 3) {
			this.UserDetailsStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Username must be at least 3 characters";
			}

			return false;
		}

		if (String(this.userDetailsRef.Username).indexOf(" ") != -1) {
			this.UserDetailsStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Username cannot contain spaces";
			}

			return false;
		}

		if (this.UsernameMustMatchEmail == true && String(this.emailRef.Email) != "") {
			var Username: string = String(this.userDetailsRef.Username);
			var EmailWithAt: string = "";
			var EmailWithoutAt: string = "";
			var DomainOption: string = String(this.emailRef.DomainOption);

			if (DomainOption == "Manual") {
				EmailWithAt = this.emailRef.Email;
				EmailWithoutAt = EmailWithAt.substring(0, EmailWithAt.indexOf("@"));
			} else {
				EmailWithoutAt = this.emailRef.Email;
				EmailWithAt = EmailWithoutAt + "@" + String(this.emailRef.EmailDomain.EmailProviderEmailInfo);
			}

			if (this.UsernameEmailMustHaveDomain == true && Username != EmailWithAt) {
				if (ShowErrorMessage) {
					this.errorMessage = "Username and email must match, ex. Username should be " + this.emailRef.Email;
				}

				this.UserDetailsStatus = 2;
				return false;
			} else if (this.UsernameEmailMustHaveDomain == false && Username != EmailWithAt && Username != EmailWithoutAt) {
				if (ShowErrorMessage) {
					this.errorMessage =
						"Username and email must match, ex. Username should be " + this.emailRef.Email + " or email should be " + this.userDetailsRef.Username;
				}

				this.UserDetailsStatus = 2;
				return false;
			}
		}

		return true;
	}

	ValidPassword(ShowErrorMessage) {
		// 10.14, don't edit passwords
		// Users must have valid email address and use reset password link
		return true;

		// //Edit mode starts with no password filled in
		// if (
		// 	//Add Mode
		// 	(this.EditMode == false && this.userDetailsRef.Password == "") ||
		// 	//Edit Mode and confirm password is filled in for some reason
		// 	(this.EditMode == true &&
		// 		this.userDetailsRef.ConfirmPassword != null &&
		// 		this.userDetailsRef.ConfirmPassword != "" &&
		// 		(this.userDetailsRef.Password == null || this.userDetailsRef.Password == ""))
		// ) {
		// 	this.UserDetailsStatus = 2;

		// 	if (ShowErrorMessage) {
		// 		//Add Mode
		// 		if (this.EditMode == false) {
		// 			this.errorMessage = "Enter a password";
		// 		}
		// 		//Edit Mode
		// 		else {
		// 			this.errorMessage =
		// 				"Confirm password is filled in but Password is not. Fill in both if you are trying to change the users password. Leave both blank if you don't want to change their password.";
		// 		}
		// 	}

		// 	return false;
		// }

		// if (
		// 	//Add mode and confirm password not filled in
		// 	(this.EditMode == false && this.userDetailsRef.ConfirmPassword == "") ||
		// 	//Edit mode and password is filled in but confirm password is not
		// 	(this.EditMode == true &&
		// 		this.userDetailsRef.Password != null &&
		// 		this.userDetailsRef.Password != "" &&
		// 		(this.userDetailsRef.ConfirmPassword == null || this.userDetailsRef.ConfirmPassword == ""))
		// ) {
		// 	this.UserDetailsStatus = 2;

		// 	if (ShowErrorMessage) {
		// 		this.errorMessage = "Confirm password";
		// 	}

		// 	return false;
		// }

		// //Passwords match
		// if (
		// 	//Add Mode
		// 	(this.EditMode == false && this.userDetailsRef.Password != this.userDetailsRef.ConfirmPassword) ||
		// 	//Edit Mode, passwords are filled in but don't match
		// 	(this.EditMode == true &&
		// 		this.userDetailsRef.Password != "" &&
		// 		this.userDetailsRef.Password != null &&
		// 		this.userDetailsRef.ConfirmPassword != "" &&
		// 		this.userDetailsRef.ConfirmPassword != null &&
		// 		this.userDetailsRef.Password != this.userDetailsRef.ConfirmPassword)
		// ) {
		// 	this.UserDetailsStatus = 2;

		// 	if (ShowErrorMessage) {
		// 		this.errorMessage = "Passwords do not match";
		// 	}

		// 	return false;
		// }

		// if (String(this.userDetailsRef.Password).indexOf(" ") != -1) {
		// 	this.UserDetailsStatus = 2;

		// 	if (ShowErrorMessage) {
		// 		this.errorMessage = "Password cannot contain spaces";
		// 	}
		// 	return false;
		// }

		// if (
		// 	//Add mode and password is under the minium length
		// 	(this.EditMode == false && this.userDetailsRef.Password.length < this.userDetailsRef.PasswordMinLength) ||
		// 	//Edit mode and password is being changed but is under the minium length
		// 	(this.EditMode == true &&
		// 		this.userDetailsRef.Password != null &&
		// 		this.userDetailsRef.Password != "" &&
		// 		this.userDetailsRef.Password.length < this.userDetailsRef.PasswordMinLength)
		// ) {
		// 	this.UserDetailsStatus = 2;

		// 	if (ShowErrorMessage) {
		// 		this.errorMessage = "Password must be at least " + this.userDetailsRef.PasswordMinLength + " characters";
		// 	}

		// 	return false;
		// }

		// if (
		// 	//Add Mode
		// 	(this.EditMode == false && this.GetNumbers(this.userDetailsRef.Password) < this.userDetailsRef.PasswordMinNumbers) ||
		// 	//Edit Mode and password is being changed
		// 	(this.EditMode == true &&
		// 		this.userDetailsRef.Password != null &&
		// 		this.userDetailsRef.Password != "" &&
		// 		this.GetNumbers(this.userDetailsRef.Password) < this.userDetailsRef.PasswordMinNumbers)
		// ) {
		// 	this.UserDetailsStatus = 2;

		// 	if (ShowErrorMessage) {
		// 		this.errorMessage = "Password must contain at least " + this.userDetailsRef.PasswordMinNumbers + " numbers";
		// 	}

		// 	return false;
		// }

		// if (
		// 	//Add Mode
		// 	(this.EditMode == false && this.GetSpecialChars(this.userDetailsRef.Password) < this.userDetailsRef.PasswordMinSpecialChars) ||
		// 	//Edit Mode and password is being changed
		// 	(this.EditMode == true &&
		// 		this.userDetailsRef.Password != null &&
		// 		this.userDetailsRef.Password != "" &&
		// 		this.GetSpecialChars(this.userDetailsRef.Password) < this.userDetailsRef.PasswordMinSpecialChars)
		// ) {
		// 	this.UserDetailsStatus = 2;

		// 	if (ShowErrorMessage) {
		// 		this.errorMessage = "Password must contain at least " + this.userDetailsRef.PasswordMinSpecialChars + " special characters";
		// 	}

		// 	return false;
		// }

		// return true;
	}

	GetNumbers(pass: string) {
		var count = 0;

		for (var i = 0; i < pass.length; i++) {
			var next = pass.substr(i, 1);

			if (!Object.is(Number(next), NaN)) {
				count++;
			}
		}

		return count;
	}

	GetSpecialChars(pass: string) {
		var count = 0;
		var letters = "abcdefghijklmnopqrstuvwxyz";

		for (var i = 0; i < pass.length; i++) {
			var next = pass.substr(i, 1);

			//Not a number and not a letter
			if (Object.is(Number(next), NaN) && letters.indexOf(next.toLowerCase()) == -1) {
				count++;
			}
		}

		return count;
	}

	SchoolsCheckErrors(ShowErrorMessage) {
		// console.log("SchoolsCheckErrors");

		//
		// Check Loading
		//
		if (this.SchoolRoleLoading == true) {
			// this.SchoolsStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Schools Still Loading";
			}

			return false;
		}

		//
		// No Check?
		//
		// Need >= 1 Schools + >= 1 Roles
		// OR >= 1 User Groups
		//
		// Check User Groups count > 0? || School Count > 0
		//

		if (this.userGroupRef.lstUserGroup.length == 0 && this.schoolRef.lstSchool.length == 0) {
			this.SchoolsStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Must have at least one School or User Group assigned to the user.";
			}

			return false;
		}

		this.SchoolsStatus = 1;
		return true;
	}

	RolesCheckErrors(ShowErrorMessage) {
		// console.log("RolesCheckErrors");

		//
		// Check Loading
		//
		if (this.SchoolRoleLoading == true) {
			// this.RolesStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Roles Still Loading";
			}

			return false;
		}

		var AnyMissing: any = false;
		var DistrictLevelError: any = false;
		if (this.schoolRef.lstSchool.length > 0) {
			// for(var z = 0; z < this.roleRef.SchoolRoleData.entries.length; z++){
			//   var next = this.roleRef.SchoolRoleData.entries[z];

			//   console.log(next);

			//   if(next.value == undefined || next.value.length == 0){
			//     this.RolesStatus = 2;

			//     if(ShowErrorMessage){
			//       this.errorMessage = "School " + next.key.SchoolFullName  + " needs at least 1 role assigned to it.";
			//     }

			//     return;
			//   }
			// }

			this.roleRef.SchoolRoleData.forEach((value, key) => {
				// console.log("Checking:");
				// console.log("Key");
				// console.log(key);
				// console.log("Value");
				// console.log(value);

				if (value == undefined || value.length == 0) {
					this.RolesStatus = 2;

					if (ShowErrorMessage) {
						this.errorMessage = "School " + key.SchoolFullName + " needs at least 1 role assigned to it.";
					}

					AnyMissing = true;

					return false;
				}

				//
				// School User, check for District Level Roles
				//
				if (this.userDetailsRef.UserLevel.UserLevelID == 3) {
					// console.log("School Level User Check");
					for (var z = 0; z < value.length; z++) {
						var next = value[z];

						if (next.UserLevelID < 3) {
							if (ShowErrorMessage) {
								this.errorMessage = "School " + key.SchoolFullName + " has a District Level Role assigned to a School Level user.";
							}
							DistrictLevelError = true;
							this.RolesStatus = 2;
							return false;
						}
					}
				}
			});
		}

		if (!AnyMissing && !DistrictLevelError) {
			this.RolesStatus = 1;
			return true;
		} else {
			return false;
		}
	}

	UserGroupsCheckErrors(ShowErrorMessage) {
		// console.log("UserGroupsCheckErrors");

		//
		// Check Loading
		//
		if (this.userGroupRef.loading == true) {
			// this.UserDetailsStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "User Groups Still Loading";
			}

			return false;
		}

		if (this.userGroupRef.lstUserGroup.length == 0 && this.schoolRef.lstSchool.length == 0) {
			this.UserGroupsStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Must have at least one School or User Group assigned to the user.";
			}

			return false;
		}

		//
		// Check that no District level user groups are assigned to school users
		//
		if (this.userDetailsRef.UserLevel.UserLevelID == 3) {
			var DistrictLevelGroup = false;
			for (var z = 0; z < this.userGroupRef.lstUserGroup.length; z++) {
				var next = this.userGroupRef.lstUserGroup[z];

				if (next.UserLevelID == 1) {
					DistrictLevelGroup = true;
					break;
				}
			}

			if (DistrictLevelGroup) {
				this.UserGroupsStatus = 2;

				if (ShowErrorMessage) {
					this.errorMessage = "Can't assign District Level User Groups to School Level Users";
				}

				return false;
			}
		}

		this.UserGroupsStatus = 1;
		return true;
	}

	EmailCheckErrors(ShowErrorMessage) {
		// console.log("EmailCheckErrors");

		//
		// Check Loading
		//
		if (this.emailRef.Processing == true) {
			// this.UserDetailsStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Email Still Loading";
			}

			return false;
		}

		if (this.emailRef.Email == "") {
			this.EmailStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Enter an email";
			}

			return false;
		}

		if (this.emailRef.EmailDomain == undefined && this.emailRef.DomainOption != "Manual") {
			this.EmailStatus = 2;

			if (ShowErrorMessage) {
				this.errorMessage = "Select an email domain";
			}

			return false;
		}

		if (this.emailRef.Email.indexOf("@") != -1 && this.emailRef.DomainOption != "Manual") {
			this.EmailStatus = 2;

			if (ShowErrorMessage) {
				var SuggestEmail = String(this.emailRef.Email).substring(0, this.emailRef.Email.indexOf("@"));

				this.errorMessage = "Email should not contain an @. Entered Email: " + this.emailRef.Email + ", should look like: " + SuggestEmail;
			}

			return false;
		}

		if (this.UsernameMustMatchEmail == true) {
			var Username: string = String(this.userDetailsRef.Username);
			var EmailWithAt: string = "";
			var EmailWithoutAt: string = "";
			var DomainOption: string = String(this.emailRef.DomainOption);

			if (DomainOption == "Manual") {
				EmailWithAt = this.emailRef.Email;
				EmailWithoutAt = EmailWithAt.substring(0, EmailWithAt.indexOf("@"));
			} else {
				EmailWithoutAt = this.emailRef.Email;
				EmailWithAt = EmailWithoutAt + "@" + String(this.emailRef.EmailDomain.EmailProviderEmailInfo);
			}

			if (this.UsernameEmailMustHaveDomain == true && Username != EmailWithAt) {
				if (ShowErrorMessage) {
					this.errorMessage = "Username and email must match, ex. Username should be " + this.emailRef.Email;
				}

				this.EmailStatus = 2;
				return false;
			} else if (this.UsernameEmailMustHaveDomain == false && Username != EmailWithAt && Username != EmailWithoutAt) {
				if (ShowErrorMessage) {
					this.errorMessage =
						"Username and email must match, ex. Username should be " + this.emailRef.Email + " or email should be " + this.userDetailsRef.Username;
				}

				this.EmailStatus = 2;
				return false;
			}
		}

		this.EmailStatus = 1;
		return true;
	}

	onlstSchoolChanged(val) {
		// console.log("Schools Changed");

		this.lstSchool = val;

		// console.log(this.lstSchool);
	}

	//#endregion
	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////////////////

	IsSU() {
		if (this.UserID == undefined) {
			return false;
		} else {
			return this.UserID == 0;
		}
	}

	ShowUserGroups() {
		if (this.ModifyUserShowUserGroups == -1 && this.IsSU() == false) {
			return false;
		} else if (this.ModifyUserShowUserGroups == 0) {
			return false;
		} else {
			return true;
		}
	}

	IsLoading() {
		if (this.userDetailsRef == undefined) {
			return true;
		} else {
			return this.Processing == true || this.SchoolRoleLoading == true || this.userDetailsRef.IsLoading() == true;
		}
	}

	//////////////////////////////////////////////////////////////////////////////////
}
